import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { InputField } from '../../../Input'
import {
  USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH,
  USER_FORM_LAST_NAME_FIELD_MAX_LENGTH,
} from '../../User.constants'
import { getUserFormNameFieldNextValue } from '../../User.utils'
import {
  USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME,
  USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME,
} from '../UserEditUsernameFormModal.constants'

function UserEditUsernameFormModalFields() {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikField
        autoFocus
        clearable
        Component={InputField}
        Field={FieldStackedLabel}
        fieldComponentProps={{
          label: `${t('User.FirstNameLabelKey')}:`,
          required: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        getNextValue={getUserFormNameFieldNextValue}
        maxLength={USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH}
        name={USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME}
        placeholder={t('User.FirstNamePlaceholderKey')}
      />
      <FormikField
        clearable
        Component={InputField}
        Field={FieldStackedLabel}
        fieldComponentProps={{
          label: `${t('User.LastNameLabelKey')}:`,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        getNextValue={getUserFormNameFieldNextValue}
        maxLength={USER_FORM_LAST_NAME_FIELD_MAX_LENGTH}
        name={USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME}
        placeholder={t('User.LastNamePlaceholderKey')}
      />
    </FormFieldsContainer>
  )
}

export default UserEditUsernameFormModalFields
